import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { VesselsService } from '../../../../../services/vessels.service';
import { DatePipe } from '@angular/common';
import { PoolingPortalService } from '../../../../../services/pooling-portal.service';
import { StorageService } from '../../../../../services/storage.service';
import { DistributionDataService } from '../../../../../services/distributionData.service';
import { Subscription } from 'rxjs';
import { EditShipModel, Setting } from '../../../../../interface/fleetList.interface';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-edit-ship-details',
  templateUrl: './edit-ship-details.component.html',
  styleUrls: ['./edit-ship-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditShipDetailsComponent {

  @Input() iEditShipForm: any;
  @Input() shipDetail: any;
  @Input() owners: any;
  @Input() subpool: any;
  @Output() closeEditShip = new EventEmitter();

  public editShipForm: UntypedFormGroup;
  subscription: Subscription;

  viewModel: EditShipModel  = {
    submit:false,
    isClosePenaltyChecked: false,
    editShipFormHasChanges:false,
    minDate: new Date(),
    effectiveFormDate:new Date(),
    closeEffectiveDate:new Date(),
    selectedSubpool: '',
    selectedOwners: '',
    existUpdatePoolPoint: '',
    existPoolPointEffectedDate: '',
    fleet:'',
    ownerList:[]
  }
  setting:Setting  = {
    showCloseIcon: false, 
    backdropClick: false
  } 

  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    public datepipe: DatePipe,
    private _poolingPortalService: PoolingPortalService,
    private toasterService: ToasterService,
    private _storageService: StorageService,
    private _distributionDataService: DistributionDataService
  ) {
  }

  createEditShipForm() {
    this.editShipForm = this.fb.group({
      subPool: [this.viewModel?.selectedSubpool, Validators.required],
      owners: [this.viewModel?.selectedOwners, Validators.required],
      newPoolPoint: [this.viewModel?.existUpdatePoolPoint, [Validators.required,Validators.pattern("^[0-9]{0,3}(([\\.]{1}[0-9]{0,3})|())$")]],
      effectiveFormDate: [this.viewModel?.existPoolPointEffectedDate,Validators.required],
    });
  }

  ngOnInit() {
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.viewModel.fleet = fleet;
        this.getOwnerList();
      }
    )
    this.viewModel.selectedSubpool = this.shipDetail?.subPool;
    this.viewModel.existUpdatePoolPoint = this.shipDetail?.updatedPoolPoint ? String(this.shipDetail?.updatedPoolPoint) : "";
    this.viewModel.existPoolPointEffectedDate = (this.shipDetail?.poolPointEffectiveFrom && new Date(this.shipDetail?.poolPointEffectiveFrom).getTime() > new Date().getTime()) ? this.datepipe.transform(this.shipDetail?.poolPointEffectiveFrom, "dd.MM.yyyy") : "";
    let date = new Date();
    this.viewModel.minDate = new Date((date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + (date.getDate()));
    this.createEditShipForm();
    this.onCreateEditShipFormChanges();
    
  }
  getOwnerList() {
    this._distributionDataService.getOwnerList(this.viewModel.fleet)
      .subscribe({
        next: (res:any) => {
          this.viewModel.ownerList = res.data.getOwnersList.data;
          this.viewModel.selectedOwners = this._poolingPortalService.getVslOwnerLabel(this.shipDetail?.vslOwner,this.viewModel.ownerList);
          this.editShipForm.patchValue({ owners: this.viewModel.selectedOwners });
        }
      });
  }

  selectedDate(event: any) {
    let selectDate = new Date(event);
    let effectiveFormDate = selectDate.getDate().toString().padStart(2, "0") + '.' + (selectDate.getMonth() + 1).toString().padStart(2, "0") + '.' + selectDate.getFullYear();
    this.editShipForm.patchValue({ effectiveFormDate: effectiveFormDate });
  }

  addUpdatePenalty(dataList: any) {
    this._vesselService.addUpdatePenaltyData(dataList)
      .subscribe({
        next: (res) => {
          if (res.data.addUpdatePenaltyData.success) {
            this.closePopup();

          }
        }
      });
  }

  submitShip() {
    this.viewModel.submit = true;
    const isFormValid = (): boolean => Object.values(this.editShipForm.controls).filter(c => c.invalid)?.length === 0;
    if (!isFormValid()) {
        return;
    }
    if (isFormValid() && this.viewModel.editShipFormHasChanges) {
      let effectiveForm = this.editShipForm.value.effectiveFormDate.split(".");
      let data = new Date(effectiveForm[2] + '-' + effectiveForm[1] + '-' + effectiveForm[0]);
      let effectiveFormDate = this.editShipForm.value.effectiveFormDate ? this.datepipe.transform(data, 'yyyy-MM-dd') : null;
      let dataList = {
        vslNumber: this.shipDetail?.vslNumber,
        poolPoint: this.editShipForm.value.newPoolPoint ? parseFloat(this.editShipForm.value.newPoolPoint) : null,
        poolPointEffectiveFrom: effectiveFormDate,
      };
      this._vesselService.updatePoolPointData(dataList)
        .subscribe({
          next: (res) => {
            if (res.data.updatePoolPointData.success) {
              this._storageService.putDataInStorage("listReloadAction", "yes");
              this.closePopup();
              this.toasterService.openToast('Success', res.data.updatePoolPointData.message);
            }
          }
        });
    }
  }


  public closePopup() {
    this.closeEditShip.emit(false);
    document.body.style.overflow = "auto";
  }

  onCreateEditShipFormChanges(): void {
    const initialValue = this.editShipForm.value;
    const EffectiveFormDatecontrol = this.editShipForm.controls["effectiveFormDate"];
    this.editShipForm.valueChanges.subscribe((formValue) => {
      if (formValue.newPoolPoint && formValue.newPoolPoint != null && formValue.newPoolPoint != "") {
        EffectiveFormDatecontrol.setValidators([Validators.required]);
        EffectiveFormDatecontrol.updateValueAndValidity({ onlySelf: true });
      } else {
        EffectiveFormDatecontrol.removeValidators([Validators.required]);
        EffectiveFormDatecontrol.updateValueAndValidity({ onlySelf: true });
      }
      this.viewModel.editShipFormHasChanges = Object.keys(initialValue).some(key => this.editShipForm.value[key] != initialValue[key]);
    })
  }
}

